import { render, staticRenderFns } from "./SearchLayout.vue?vue&type=template&id=dd840878&scoped=true"
import script from "./SearchLayout.vue?vue&type=script&lang=ts"
export * from "./SearchLayout.vue?vue&type=script&lang=ts"
import style0 from "./SearchLayout.vue?vue&type=style&index=0&id=dd840878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd840878",
  null
  
)

export default component.exports